var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.result.data, function(item, index) {
        return _c(
          "div",
          { key: `result-item-${index}` },
          [
            _c(
              "callout",
              {
                staticClass: "mb-3 callout-extended",
                attrs: {
                  "border-color": _vm.getColor(item.paymentJournalStatusId),
                  "has-toggle": false
                }
              },
              [
                _c("div", { staticClass: "row mt-2 row-container" }, [
                  _c(
                    "div",
                    { staticClass: "col-2 col-sm col-6 border-right status" },
                    [
                      _c("balloon", {
                        staticClass:
                          "mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center w-90 ml-3 mb-3 font-weight-bold",
                        attrs: {
                          "background-color": `bg-${_vm.getColor(
                            item.paymentJournalStatusId
                          )}`,
                          color: "font-weight-bold",
                          text: item.paymentJournalStatusDesc
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 col-sm col-6 pl-3 pl-md-5 pl-sm-4 pt-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-secondary-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Número de Jornal: ")]
                      ),
                      _c(
                        "span",
                        { staticClass: "color-black font-16 font-weight-bold" },
                        [_vm._v(" " + _vm._s(item.paymentJournalNumber) + " ")]
                      )
                    ]
                  ),
                  _c("div", {
                    staticClass:
                      "col-md-12 border-top mx-2 mr-4 d-none d-md-none d-sm-block"
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-secondary-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Conteo de Pagos: ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "color-black font-16 font-weight-normal ml-0 ml-md-4 ml-sm-0 pl-0 pl-md-2 pl-sm-0"
                        },
                        [_vm._v(" " + _vm._s(item.paymentCount) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-secondary-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Total Pagado: ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "color-black font-16 font-weight-normal"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("price")(item.paymentTotalAmount)) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4 pt-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-secondary-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Fecha Creado: ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "color-black font-16 font-weight-normal"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm._f("date")(item.createdDate)) + " "
                          ),
                          _c("i", [
                            _vm._v(_vm._s(_vm._f("hour")(item.createdDate)))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm.showJournalType
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-2 col-sm col-6 d-flex align-items-center justify-content-end mt-4 mt-md-0 mt-sm-4 pr-4"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "journal-type-badge",
                              class: _vm.getJournalTypeClass(
                                item.paymentJournalTypeId
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getJournalTypeLabel(
                                      item.paymentJournalTypeId
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 col-sm col-6 text-center mt-4 mt-md-0 mt-sm-4 pr-5 pt-1"
                    },
                    [
                      _c("drop-down", {
                        attrs: {
                          "data-item": { item, index },
                          items: _vm.actionItems
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: {
              data: _vm.result.pagination,
              "page-size": 15,
              "show-text": true
            },
            on: { "pagination-go-page": _vm.onPageChange }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }